import * as React from "react";

const SvgCircleDollar = (props) => {
  let strokeDasharrayValue=`${props.percent} 100`;
  return (
    <svg viewBox="0 0 64 64" class="pie">
    <circle r="25%" cx="50%" cy="50%" strokeDasharray={strokeDasharrayValue}>
    </circle>
    </svg>
  );
} 

export default SvgCircleDollar;
